class BrandSelector extends HTMLElement {
  constructor() {
    super();
    this.noResults = this.querySelector('[data-no-results]');
    this.backButton = this.querySelector('[data-cancel-brand-filter]');
    this.searchInput = this.querySelector('[data-brand-search]');
    this.letterFilterButtons = this.querySelectorAll('.alphabet-link');
    this.selectedLetter = null;
    this.bindEvents();
  }

  bindEvents() {
    this.letterFilterButtons.forEach((buttons) => {
      buttons.addEventListener('click', () => this.filterByLetter(buttons.dataset.letter));
    });
    this.backButton.addEventListener('click', () => this.reset());
    this.searchInput.addEventListener('input', (e) => this.filterBySearch(e.target.value));
  }

  normalizeForSearch(str) {
    return str
      .normalize('NFKD')
      .replace(/\p{M}/gu, '')
      .replace(/[øØ]/g, 'o')
      .replace(/[æÆ]/g, 'ae')
      .replace(/[ß]/g, 'ss')
      .replace(/[ðÐ]/g, 'd')
      .replace(/[þÞ]/g, 'th')
      .replace(/[łŁ]/g, 'l')
      .replace(/[đĐ]/g, 'd')
      .toLowerCase();
  }

  filterByLetter(letterFilter) {
    this.letterFilterButtons.forEach((link) => link.removeAttribute('data-active'));

    if (this.selectedLetter === letterFilter) {
      this.selectedLetter = null;
      this.reset();
      return;
    }

    this.letterFilterButtons.forEach((link) => {
      if (link.dataset.letter === letterFilter) {
        link.setAttribute('data-active', '');
      }
    });

    let visibleCount = 0;

    this.selectedLetter = letterFilter;

    for (const group of this.querySelectorAll('[data-group]')) {
      const isVisible = group.dataset.group === letterFilter;
      group.classList.toggle('hidden', !isVisible);
      visibleCount += isVisible ? group.querySelectorAll('.brand-item').length : 0;
    }

    this.updateUI(visibleCount, letterFilter);
  }

  filterBySearch(searchTerm) {
    let visibleCount = 0;
    const normalizedSearch = this.normalizeForSearch(searchTerm);

    this.letterFilterButtons.forEach((button) => {
      button.removeAttribute('data-active');
    });

    if (normalizedSearch === '') {
      this.reset();
      return;
    }
    this.querySelectorAll('[data-group]').forEach((group) => {
      const visibleItems = Array.from(group.querySelectorAll('.brand-item')).filter((item) => {
        const text = this.normalizeForSearch(item.textContent);
        const matchesSearch = text.includes(normalizedSearch);

        const isVisible = matchesSearch;
        item.classList.toggle('hidden', !isVisible);
        return isVisible;
      });

      group.classList.toggle('hidden', visibleItems.length === 0);
      visibleCount += visibleItems.length;
    });

    this.querySelectorAll('collapsible-element').forEach((element) => {
      element.classList.add('collapsible-is-open');
    });

    this.updateUI(visibleCount, searchTerm);
  }

  updateUI(visibleCount, hasFilter) {
    this.noResults.classList.toggle('hidden', visibleCount > 0);
    this.backButton.classList.toggle('hidden', !hasFilter);
  }

  reset() {
    this.selectedLetter = null;
    this.searchInput.value = '';
    this.noResults.classList.add('hidden');
    this.backButton.classList.add('hidden');
    this.letterFilterButtons.forEach((button) => {
      button.removeAttribute('data-active');
    });

    this.querySelectorAll('[data-group], .brand-item').forEach((element) => {
      element.classList.remove('hidden');
    }); // collapsible-element and close each element
    this.querySelectorAll('collapsible-element').forEach((element) => {
      element.classList.remove('collapsible-is-open');
    });
  }
}

if (!customElements.get('brand-selector')) {
  customElements.define('brand-selector', BrandSelector);
}
